import baseEnvConstants from './environment.development';

let prodEnvConstants = { ...baseEnvConstants };

// 依據建置模式 (REACT_APP_MODE) 使用不同的常數
switch (process.env.REACT_APP_MODE) {
  // UAT
  case 'uat':
    prodEnvConstants = {
      ...prodEnvConstants,
      apiUrl: 'https://ewantuat.wwunion.com/ensure/api',
      featureToggle: false
    };
    break;
  // PROD
  case 'prod':
    prodEnvConstants = {
      ...prodEnvConstants,
      apiUrl: 'https://ensure.wwunion.com/ensure/api',
      gtmId: 'GTM-TKHGJVRD',
      featureToggle: false
    };
    break;
}

export default prodEnvConstants;
